module.exports = __webpack_public_path__ + "img/rent1.310b4867.png";